import Media from './Media.container';

export default Media;
